export const ERROR_CODES = {
  NOT_FOUND: {
    code: 404,
    title: "Page not found",
    message: "The page you are looking for does not exist.",
  },
  NETWORK: {
    code: "OFFLINE",
    title: "No Internet Connection",
    message: "Please check your network connection and try again.",
  },
  SERVER: {
    code: 500,
    title: "Something went wrong",
    message: "It's not you, it's us. Please try again later.",
  },
  INTERNAL: {
    code: "INTERNAL ERROR",
    title: "Unexpected Error",
    message: "Something went wrong inside the application. Please refresh or try again.",
  },
};
